import { Fragment } from "react";
import usePage from "../hooks/usePage";
import Menu from "../modules/public/menu/menu";
import Footer from "../modules/public/footer/footer";
import { HiDownload } from "react-icons/hi";
import { Link } from "react-router-dom";
import backendUrl from "../utilities/backendUrl";

const Application = () => {
  const { pageSliders, pageImage, pageText } = usePage();

  return (
    <Fragment>
      <Menu />

      <main className="flex-grow-1">
        {pageSliders}
        {pageText}

        <div className="container d-flex justify-content-end my-4">
          <Link
            to={backendUrl + "/avaex.apk"}
            download={true}
            className="d-flex"
          >
            <div
              className="d-flex justify-content-between align-items-center border border-2 py-1 px-2 rounded-2 bg-success text-white"
              style={{ width: "230px" }}
            >
              <span>
                <HiDownload />
              </span>
              <span>لینک دانلود مستقیم اپلیکیشن</span>
            </div>
          </Link>
        </div>
        {pageImage}
      </main>

      <Footer />
    </Fragment>
  );
};

export default Application;
